import { render, staticRenderFns } from "./HomeFeaturedHeader.vue?vue&type=template&id=37d74adc&scoped=true&"
import script from "./HomeFeaturedHeader.vue?vue&type=script&lang=js&"
export * from "./HomeFeaturedHeader.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeaturedHeader.vue?vue&type=style&index=0&id=37d74adc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d74adc",
  null
  
)

export default component.exports